import { useState } from 'react';
import { resolverComPrioridade } from '../../domain/usecases/resolverComPrioridade';

/**
 * useTemasSazonais — flags de tema (Dia dos Namorados, Festa Junina, Copa)
 * exibidos no Jukebox cliente. Cada flag tem duas fontes: fetch inicial via
 * configuracoesService (dono do valor "db" aqui) e broadcast `update_settings`
 * (dono do valor "broadcast", já resolvido por useJukeboxBroadcast) —
 * broadcast sempre vence quando presente.
 */
export interface TemasSazonaisState {
  temaDiaNamorados: boolean;
  temaFestaJunina: boolean;
  temaCopa: boolean;
  setTemaDiaNamoradosDb(v: boolean): void;
  setTemaFestaJuninaDb(v: boolean): void;
  setTemaCopaDb(v: boolean): void;
}

export function useTemasSazonais(
  temaDiaNamoradosBroadcast: boolean | null,
  temaFestaJuninaBroadcast: boolean | null,
  temaCopaBroadcast: boolean | null,
): TemasSazonaisState {
  const [temaDiaNamoradosDb, setTemaDiaNamoradosDb] = useState(false);
  const [temaFestaJuninaDb, setTemaFestaJuninaDb] = useState(false);
  const [temaCopaDb, setTemaCopaDb] = useState(false);

  return {
    temaDiaNamorados: resolverComPrioridade(temaDiaNamoradosBroadcast, temaDiaNamoradosDb),
    temaFestaJunina:  resolverComPrioridade(temaFestaJuninaBroadcast, temaFestaJuninaDb),
    temaCopa:         resolverComPrioridade(temaCopaBroadcast, temaCopaDb),
    setTemaDiaNamoradosDb,
    setTemaFestaJuninaDb,
    setTemaCopaDb,
  };
}
